import React, { FC } from "react";
import { ButtonPrimary, ButtonSecondary, ButtonMailToSales } from "@shared/components";
import { Modal } from "@shared/components/Modal";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { getActiveAccount } from "@containers/Account/store/selectors";
import { useLocalStorage } from "@shared/hooks";
import { getAppUrl, getReisiftAppUrl, hasAccountActiveSubscription } from "@shared/utils";
import { INTEGRATIONS_REISIFT_MODAL, INTEGRATIONS_REISIFT_COUPON } from "@shared/constants/shared";
import reishiftIntegrationDesktopImg from "@assets/files/images/reisift/reisift-integration.png";
import reishiftIntegrationMobileImg from "@assets/files/images/reisift/reisift-integration-mobile.png";
import "./ModalReisiftIntegration.scss";
import { useGetOneCouponsQuery } from "@shared/api/couponApi";

import config from "../../../config";

export type ModalReisiftIntegrationProps = {
  onClose: () => void;
  onSuccess: () => void;
};

export const ModalReisiftIntegration: FC<ModalReisiftIntegrationProps> = (props) => {
  const { onClose } = props;
  const navigate = useNavigate();

  const { data: coupon } = useGetOneCouponsQuery({ name: INTEGRATIONS_REISIFT_COUPON });

  const [, setShowReisiftModal] = useLocalStorage(INTEGRATIONS_REISIFT_MODAL, false);

  const handleClose = () => {
    setShowReisiftModal(false);
    onClose();
  };

  const account = useSelector(getActiveAccount());

  const hasActiveSubs = hasAccountActiveSubscription(account);

  const handleSingUp = () => {
    if (hasActiveSubs) {
      const url = new URL(`${getReisiftAppUrl()}/oauth`);

      url.searchParams.set("client", "dataflik");
      url.searchParams.set("auth_mode", "signup");
      url.searchParams.set("returnUrl", `${getAppUrl()}/integrations/reisift`);

      if (coupon) {
        url.searchParams.set("coupon", coupon.value);
      }

      window.open(url, "_blank");
    } else {
      window.open(`${getReisiftAppUrl()}/signup`, "_blank");
    }
  };

  const handleLinkAccount = () => {
    navigate("/integrations");
    handleClose();
  };

  return (
    <Modal>
      <Modal.CloseButton onClick={handleClose} />
      <Modal.Section>
        <div className="modal-banner">
          <div className="modal-banner-inner">
            <picture>
              <source media="(max-width: 480px)" srcSet={reishiftIntegrationMobileImg} />
              <source media="(min-width: 480px)" srcSet={reishiftIntegrationDesktopImg} />
              <img src={reishiftIntegrationDesktopImg} alt="REISift Integration" />
            </picture>
          </div>
        </div>
        <Modal.Header>
          <Modal.Title>Welcome REISift Integration</Modal.Title>
        </Modal.Header>

        <Modal.Content>
          {hasActiveSubs ? (
            <>
              <Modal.Text>
                Connect your REISift account to get your AI and Niche files directly to the REISift Record management
                system.
              </Modal.Text>
              <Modal.Text>
                Don’t have an account? <b>Get powerful record and lead management system!</b>
                <br />
                <a href={config.reiSift.siteUrl} target="_blank" rel="noreferrer">
                  Learn more about REISift
                </a>
              </Modal.Text>
            </>
          ) : (
            <Modal.Text>
              Upgrade your DataFlik account and get powerful record and lead management system for FREE!
            </Modal.Text>
          )}
        </Modal.Content>

        <Modal.Actions>
          {hasActiveSubs ? (
            <>
              <ButtonSecondary onClick={handleSingUp}>{hasActiveSubs ? "Sign up for FREE" : "Sign Up"}</ButtonSecondary>
              <ButtonPrimary onClick={handleLinkAccount}>Link Account</ButtonPrimary>
            </>
          ) : (
            <ButtonMailToSales>Contact Sales</ButtonMailToSales>
          )}
        </Modal.Actions>
      </Modal.Section>
    </Modal>
  );
};
